export const routes = (prefix = `master-data`) => [
    {
        path: `/${prefix}/accounts/expense-items`,
        name: `${prefix}.accounts.expense-items.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.accounts.expense-items.index`,
                PageDescription: "Expense Items",
            },
        },
    },
];
